import {styled} from "@phntms/css-components";
import {textVariants} from "../../style-variants";
import styles from "./styles.module.scss";

export const HeroTextSectionContainer = styled('section' , {
  css: [styles.heroTextSection, 'hero-text-section'],
  variants: {
    gradient: {
      true: styles.gradient
    },
    bgImage: {
      true: styles.bgImage,
      noMargin: styles.bgImageNoMargin
    },
    expanded: {
      false: [styles.collapsed],
      true: [],
    },
    noPaddingTop: {
      true: [styles.noPaddingTop],
      false: [],
    }
  }
})

export const HeroTextContent = styled('div' , {
  css: [styles.content, 'container','smaller', 'hero-text-content'],
  variants: {

  }
})

export const HeroText = styled('div' , {
  css: [styles.text, 'medium-txt'],
  variants: {
      ...textVariants
  }
})









